import { classNames } from '@vkontakte/vkui';
import styles from './Button.module.css';

interface ButtonProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: VoidFunction;
  href?: string;
  stretched?: boolean;
  mode?: 'primary' | 'secondary';
}

export function Button(props: ButtonProps) {
  const { children, onClick, href, className, stretched = false, mode = 'primary' } = props;

  const cn = classNames(styles.root, styles[mode], { [styles.stretched]: stretched }, className);

  if (href) {
    return (
      <a href={href} onClick={onClick} className={cn}>
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={cn}>
      {children}
    </button>
  );
}
